import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FieldActivitySharedWithMe } from '../_models/fieldActivitySharedWithMe';
import { environment } from '../../../environments/environment';
import { FieldActivityShared } from '../_models/fieldActivityShared';

@Injectable()
export class FieldActivitySharedService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  saveFieldActivitiesShared(faSharedItem: FieldActivityShared): Observable<FieldActivityShared> {
    const faShared = { ...faSharedItem };
    delete faShared.lastUpdated;
    delete faShared.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    faShared.companyId = companySelected ? companySelected.id : null;
    console.log(faShared);
    if (faShared.id) {
      return this.http
        .put<FieldActivityShared>(
          this.apiBaseUrl + 'api/private/v1/fieldActivitiesShared/' + faShared.id,
          faShared
        )
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<FieldActivityShared>(
          this.apiBaseUrl + 'api/private/v1/fieldActivitiesShared',
          faShared
        )
        .pipe(map((response) => response));
    }
  }

  getFieldActivitiesSharedWithMe(type: string): Observable<Array<FieldActivitySharedWithMe>> {
    return this.http
      .get<
        Array<FieldActivitySharedWithMe>
      >(this.apiBaseUrl + 'api/private/v1/fieldActivitiesShared?type=' + type)
      .pipe(map((response) => response));
  }

  confirmSharedWithMe(item: FieldActivitySharedWithMe): Observable<any> {
    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    item.companyId = companySelected ? companySelected.id : null;
    return this.http
      .post(this.apiBaseUrl + 'api/private/v1/fieldActivitySharedAcceptance/' + item.id, item)
      .pipe(map((response) => response));
  }

  refuseSharedWithMe(item: FieldActivitySharedWithMe) {
    item.status = 'REJECTED';
    return this.http
      .put(this.apiBaseUrl + 'api/private/v1/fieldActivitiesShared/' + item.id, item)
      .pipe(map((response) => response));
  }

  permanentDeleteSharedWithMe(item: FieldActivitySharedWithMe) {
    return this.http
      .delete(this.apiBaseUrl + 'api/private/v1/fieldActivitiesShared/' + item.id)
      .pipe(map((response) => response));
  }
}
